export enum TagColor {
  Alert = 'alert',
  Error = 'error',
  Red = 'red',
  Orange = 'orange',
  Warning = 'warning',
  Warn = 'warn',
  Yellow = 'yellow',
  Success = 'success',
  Green = 'green',
  Primary = 'primary',
  Info = 'info',
  Blue = 'blue',
  Purple = 'purple',
  NeutralDark = 'neutral-dark',
  Gray = 'gray',
  NeutralLight = 'neutral-light',
  LightGray = 'light-gray'
}
